// extracted by mini-css-extract-plugin
export default {"container":"RevisionHistory_container__uPrtV"};